/* eslint-disable no-empty-pattern */
import http from '@plugins/axios';
import { queryString } from '@utils/format';

export const actions = {
  async fetch({}, payload) {
    const url = `/kategori?${queryString(payload.params)}`;
    return await http.get(url).then(({ data }) => data);
  },

  async detail({}, payload) {
    const url = `/kategori/${payload}`;
    return await http.get(url).then(({ data }) => data);
  },

  create({}, payload) {
    const url = `/kategori`;
    return http.post(url, payload.params);
  },

  update({}, payload) {
    const url = `/kategori/${payload.id}`;
    return http.patch(url, payload.params);
  },

  status({}, payload) {
    const url = `/kategori/${payload.id}/${payload.status}`;
    return http.post(url);
  },

  delete({}, payload) {
    const url = `/kategori/${payload.id}`;
    return http.delete(url);
  },
};
